<template>
  <div class="board-size-control">
    <button-tooltip
      :tooltip="`Decrease board size to ${prevSize}px`"
      size="is-small"
      type="is-light"
      icon-left="search-minus"
      :disabled="currentSizeIndex === 0"
      @click="decreaseSize"
    />

    <button-tooltip
      tooltip="Current board size"
      type="is-info is-light"
      size="is-small"
      :label="`${currentSize}px`"
      width="3rem"
    />

    <button-tooltip
      :tooltip="`Increase board size to ${nextSize}px`"
      size="is-small"
      type="is-light"
      icon-left="search-plus"
      :disabled="currentSizeIndex === sizes.length - 1"
      @click="increaseSize"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";
import { BOARD_SIZES } from "@/mixins/boardSizeMixin";

export default {
  name: "BoardSizeControl",

  components: {
    ButtonTooltip,
  },

  data() {
    return {
      sizes: Object.values(BOARD_SIZES),
    };
  },

  computed: {
    ...mapGetters(["getScenarioBoardSize"]),

    currentSize() {
      return this.getScenarioBoardSize;
    },

    currentSizeIndex() {
      return this.sizes.indexOf(this.currentSize);
    },

    nextSize() {
      if (this.currentSizeIndex === this.sizes.length - 1) {
        return this.currentSize;
      }
      return this.sizes[this.currentSizeIndex + 1];
    },

    prevSize() {
      if (this.currentSizeIndex === 0) {
        return this.currentSize;
      }
      return this.sizes[this.currentSizeIndex - 1];
    },
  },

  methods: {
    ...mapMutations(["setScenarioBoardSize"]),

    increaseSize() {
      const nextIndex = this.currentSizeIndex + 1;
      if (nextIndex < this.sizes.length) {
        const newSize = this.sizes[nextIndex];
        this.setScenarioBoardSize(newSize);
        this.$emit("size-changed", newSize);
      }
    },

    decreaseSize() {
      const prevIndex = this.currentSizeIndex - 1;
      if (prevIndex >= 0) {
        const newSize = this.sizes[prevIndex];
        this.setScenarioBoardSize(newSize);
        this.$emit("size-changed", newSize);
        this.triggerResize();
      }
    },
  },

  mounted() {
    // Initialize with default size if not set
    if (!this.currentSize) {
      console.log("Initializing board size to default");
      const defaultSize = 640;
      this.setScenarioBoardSize(defaultSize);
      this.$emit("size-changed", defaultSize);
    }
  },
};
</script>

<style scoped>
.board-size-control {
  display: flex;
  align-items: center;
}
</style>
